import React from 'react'
import { Trans } from 'react-i18next/icu.macro'
import BaseVerifyMobileDialog from './BaseVerifyMobileDialog'

export default function VerifyMobileDialog({ accountView, phoneNumberFormatted, ...props }) {
  const phoneNumber = phoneNumberFormatted || accountView?.smsNumber.formattedValue || ''
  const messageText = (
    <Trans i18nKey="mobile-phone-number-verify.message">
      A code was sent to <strong>{phoneNumber}</strong>. Enter it here to verify that this is the mobile number you
      would like to use to recover your FamilySearch username or reset the password.
    </Trans>
  )
  return <BaseVerifyMobileDialog {...{ messageText, ...props }} />
}
